import { useState } from "react";

/* ── Icons ── */
const IconShield = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{width:20,height:20}}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);
const IconCheck = ({ size = 10, color = "currentColor" }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{width:size,height:size}}>
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const IconSend = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:13,height:13}}>
    <line x1="22" y1="2" x2="11" y2="13"/>
    <polygon points="22 2 15 22 11 13 2 9 22 2"/>
  </svg>
);
const IconArrowLeft = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:13,height:13}}>
    <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
  </svg>
);
const IconArrowRight = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width:13,height:13}}>
    <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
  </svg>
);
const IconLock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{width:13,height:13}}>
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);

/* ── Data ── */
const DATA_CATEGORIES = [
  { label: "Payment Cards",       items: ["Mastercard","Visa","Rupay","JCB","Amex","Discover","Diners Club"] },
  { label: "Card Sensitive Data", items: ["Expiry","CVV","PIN"] },
  { label: "Contact & Identity",  items: ["Email address","Phone","Name","Address","ZIP code"] },
  { label: "Government IDs",      items: ["Aadhaar","Passport","PAN","GST","Voter ID","Driving license","Ration card","SSN","Civil ID"] },
  { label: "Financial & Health",  items: ["Bank account","Health ID"] },
  { label: "Digital Identifiers", items: ["IP address","Date","URL","Username","Policy no.","Policy name"] },
  { label: "Credentials & Keys",  items: ["Password","Access key","API key","Token","Secret key"] },
  { label: "Biometrics",          items: ["Face","Signature","Fingerprint"] },
];
const BREACH_TYPES = [
  "Unauthorised access","Accidental disclosure","Ransomware / malware",
  "Phishing attack","Insider threat","Physical theft / loss",
  "System misconfiguration","Third-party vendor breach","Other",
];
const SEVERITIES = [
  { id:"low",      label:"Low",      icon:"🟢" },
  { id:"medium",   label:"Medium",   icon:"🟡" },
  { id:"high",     label:"High",     icon:"🔴" },
  { id:"critical", label:"Critical", icon:"💀" },
];
const STEPS = ["Reporter","Breach","Severity","Data Types","Containment","Consent"];
const STEP_SUBS = [
  "Person filing this notification",
  "What happened and when",
  "Estimated impact level",
  "Select all data types involved",
  "Actions taken so far",
  "Required before submission",
];

/* ── Styles ── */
const S = {
  root: { fontFamily:"'DM Sans',system-ui,sans-serif", fontSize:14, color:"#1a1a1a", lineHeight:1.5, background:"#f6f6f4", minHeight:"100vh", padding:"28px 16px 48px" },
  // container: { maxWidth:720, margin:"0 auto" },

  /* progress */
  progWrap: { display:"flex", marginBottom:16, background:"#fff", border:"1px solid #e4e4e0", borderRadius:10, overflow:"hidden" },
  progStep: (active,done) => ({
    flex:1, padding:"9px 4px", textAlign:"center", fontSize:11, fontWeight:active?600:500,
    color: active?"#fff": done?"#555":"#aaa",
    background: active?"#1a1a1a": done?"#f0efec":"#fff",
    borderRight:"1px solid #e4e4e0", cursor: done||active?"default":"default",
    transition:"all .2s", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis",
  }),
  progStepLast: (active,done) => ({
    flex:1, padding:"9px 4px", textAlign:"center", fontSize:11, fontWeight:active?600:500,
    color: active?"#fff": done?"#555":"#aaa",
    background: active?"#1a1a1a": done?"#f0efec":"#fff",
    cursor:"default", transition:"all .2s", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis",
  }),

  /* card */
  card: { background:"#fff", border:"1px solid #e4e4e0", borderRadius:12, overflow:"hidden" },
  cardHead: { padding:"14px 20px", borderBottom:"1px solid #f0efec", display:"flex", alignItems:"center", justifyContent:"space-between" },
  cardTitle: { fontSize:14, fontWeight:600, color:"#1a1a1a", display:"flex", alignItems:"center", gap:8 },
  stepBadge: { width:22, height:22, borderRadius:"50%", background:"#1a1a1a", color:"#fff", fontSize:11, fontWeight:600, display:"flex", alignItems:"center", justifyContent:"center" },
  cardSub: { fontSize:12, color:"#999" },
  cardBody: { padding:"20px" },
  cardFoot: { padding:"11px 20px", borderTop:"1px solid #f0efec", display:"flex", alignItems:"center", justifyContent:"space-between", background:"#fafaf8" },
  refTag: { fontFamily:"'DM Mono',monospace", fontSize:11, color:"#bbb" },
  btns: { display:"flex", gap:8 },

  /* fields */
  grid2: { display:"grid", gridTemplateColumns:"1fr 1fr", gap:13 },
  grid1: { display:"grid", gridTemplateColumns:"1fr", gap:13 },
  field: { display:"flex", flexDirection:"column", gap:5 },
  lbl: { fontSize:10.5, fontWeight:600, color:"#888", letterSpacing:".05em", textTransform:"uppercase" },
  req: { color:"#e53e3e", marginLeft:2 },
  inp: { width:"100%", padding:"8px 11px", border:"1px solid #e4e4e0", borderRadius:8, fontSize:13.5, color:"#1a1a1a", fontFamily:"inherit", background:"#fff", outline:"none", lineHeight:1.5 },
  ta: { width:"100%", padding:"8px 11px", border:"1px solid #e4e4e0", borderRadius:8, fontSize:13.5, color:"#1a1a1a", fontFamily:"inherit", background:"#fff", outline:"none", resize:"vertical", minHeight:82, lineHeight:1.6 },
  sel: { width:"100%", padding:"8px 11px", border:"1px solid #e4e4e0", borderRadius:8, fontSize:13.5, color:"#1a1a1a", fontFamily:"inherit", background:"#fff", outline:"none", cursor:"pointer", appearance:"none", backgroundImage:"url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23aaa' stroke-width='2.5'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\")", backgroundRepeat:"no-repeat", backgroundPosition:"right 10px center", paddingRight:30 },

  /* severity */
  sevGrid: { display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:8, marginBottom:14 },
  sevCard: (active, cls) => {
    const map = { low:["#15803d","#f0fdf4"], medium:["#b45309","#fffbeb"], high:["#dc2626","#fef2f2"], critical:["#7c3aed","#faf5ff"] };
    const [c,bg] = active ? (map[cls]||["#1a1a1a","#f0efec"]) : ["#aaa","#fff"];
    return { padding:"13px 8px", border:`1px solid ${active?(map[cls]?.[0]||"#1a1a1a"):"#e4e4e0"}`, borderRadius:8, cursor:"pointer", textAlign:"center", background: active ? bg : "#fff", display:"flex", flexDirection:"column", alignItems:"center", gap:5, transition:"all .15s" };
  },
  sevIcon: { fontSize:20 },
  sevLabel: (active,cls) => {
    const map = { low:"#15803d", medium:"#b45309", high:"#dc2626", critical:"#7c3aed" };
    return { fontSize:12, fontWeight:500, color: active?(map[cls]||"#1a1a1a"):"#888" };
  },

  /* chips */
  catSection: { marginBottom:13 },
  catTitle: { fontSize:10, fontWeight:600, color:"#bbb", textTransform:"uppercase", letterSpacing:".06em", marginBottom:6, paddingBottom:4, borderBottom:"1px solid #f0efec" },
  chips: { display:"flex", flexWrap:"wrap", gap:5 },
  chip: (checked) => ({ display:"inline-flex", alignItems:"center", gap:5, padding:"4px 10px", border:`1px solid ${checked?"#1a1a1a":"#e4e4e0"}`, borderRadius:20, fontSize:12, color: checked?"#1a1a1a":"#888", background: checked?"#f0efec":"#fff", cursor:"pointer", userSelect:"none", transition:"all .15s", fontWeight: checked?500:400 }),
  chipBox: (checked) => ({ width:12, height:12, border:`1px solid ${checked?"#1a1a1a":"#d0d0cc"}`, borderRadius:3, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, background: checked?"#1a1a1a":"#fff", transition:"all .15s" }),

  /* privacy */
  privacyBox: { background:"#fafaf8", border:"1px solid #eeede8", borderRadius:8, padding:"13px 15px", marginBottom:13 },
  privacyTitle: { fontSize:12, fontWeight:600, color:"#555", marginBottom:9, display:"flex", alignItems:"center", gap:5 },
  privacyItem: { display:"flex", alignItems:"flex-start", gap:7, fontSize:12, color:"#777", marginBottom:5, lineHeight:1.55 },
  checkDot: { width:15, height:15, minWidth:15, borderRadius:"50%", background:"#eeecea", border:"1px solid #e0dfda", display:"flex", alignItems:"center", justifyContent:"center", marginTop:1 },

  /* consent */
  consentItem: (checked) => ({ display:"flex", alignItems:"flex-start", gap:10, padding:"10px 12px", border:`1px solid ${checked?"#ccc":"#e4e4e0"}`, borderRadius:8, marginBottom:8, cursor:"pointer", background: checked?"#fafaf8":"#fff", transition:"all .15s" }),
  cbox: (checked) => ({ width:16, height:16, minWidth:16, border:`1px solid ${checked?"#1a1a1a":"#d0d0cc"}`, borderRadius:4, display:"flex", alignItems:"center", justifyContent:"center", background: checked?"#1a1a1a":"#fff", marginTop:1, transition:"all .15s", flexShrink:0 }),
  consentText: { fontSize:12.5, color:"#555", lineHeight:1.55 },

  /* buttons */
  btnGhost: { padding:"7px 15px", border:"1px solid #e4e4e0", borderRadius:8, fontSize:13, fontWeight:500, color:"#555", background:"#fff", cursor:"pointer", fontFamily:"inherit", display:"flex", alignItems:"center", gap:6 },
  btnPrimary: { padding:"7px 17px", border:"none", borderRadius:8, fontSize:13, fontWeight:600, color:"#fff", background:"#1a1a1a", cursor:"pointer", fontFamily:"inherit", display:"flex", alignItems:"center", gap:6 },
  btnDisabled: { background:"#9ca3af", cursor:"not-allowed", opacity:0.65 },

  /* success */
  successWrap: { display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"48px 24px", textAlign:"center" },
  successIcon: { width:52, height:52, borderRadius:"50%", background:"#f0fdf4", border:"1px solid #bbf7d0", display:"flex", alignItems:"center", justifyContent:"center", marginBottom:14 },
  refPill: { marginTop:14, padding:"6px 16px", background:"#fafaf8", border:"1px solid #e4e4e0", borderRadius:8, fontFamily:"'DM Mono',monospace", fontSize:12, color:"#999" },
};

/* ── Field helpers ── */
function Field({ label, required, children }) {
  return (
    <div style={S.field}>
      <label style={S.lbl}>{label}{required && <span style={S.req}>*</span>}</label>
      {children}
    </div>
  );
}
function TextInput({ value, onChange, type="text", placeholder="" }) {
  return <input style={S.inp} type={type} value={value} placeholder={placeholder} onChange={e => onChange(e.target.value)} />;
}
function TextArea({ value, onChange, placeholder="" }) {
  return <textarea style={S.ta} value={value} placeholder={placeholder} onChange={e => onChange(e.target.value)} />;
}
function Select({ value, onChange, options }) {
  return (
    <select style={S.sel} value={value} onChange={e => onChange(e.target.value)}>
      <option value="">Select…</option>
      {options.map(o => <option key={o} value={o}>{o}</option>)}
    </select>
  );
}

/* ── Main ── */
export default function DataBreachForm() {
  const [submitted, setSubmitted] = useState(false);
  const [step, setStep] = useState(1);
  const [dataChecks, setDataChecks] = useState({});
  const [consents, setConsents] = useState({ c1:false, c2:false, c3:false });
  const [form, setForm] = useState({
    reporterName:"", jobTitle:"", department:"", contactEmail:"", phone:"", organisation:"",
    dateDiscovered:"", dateOccurred:"", breachType:"", systemsAffected:"", description:"",
    severity:"", estimatedCount:"", immediateActions:"", containedStatus:"", individualsNotified:"",
  });

  const refId = useState(() => "DBN-" + Math.random().toString(36).slice(2,8).toUpperCase())[0];
  const u = (k, v) => setForm(p => ({ ...p, [k]:v }));
  const toggleData = k => setDataChecks(p => ({ ...p, [k]:!p[k] }));
  const toggleConsent = k => setConsents(p => ({ ...p, [k]:!p[k] }));
  const stepIsValid = (stepToValidate) => {
    if (stepToValidate === 1) {
      const email = form.contactEmail.trim();
      return Boolean(
        form.reporterName.trim()
        && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
      );
    }
    if (stepToValidate === 2) {
      return Boolean(
        form.dateDiscovered
        && form.breachType
        && form.systemsAffected.trim()
        && form.description.trim()
      );
    }
    if (stepToValidate === 3) return Boolean(form.severity);
    if (stepToValidate === 4) {
      const estimatedCount = Number(form.estimatedCount);
      return Object.values(dataChecks).some(Boolean)
        && Number.isInteger(estimatedCount)
        && estimatedCount > 0;
    }
    if (stepToValidate === 5) {
      return Boolean(form.immediateActions.trim() && form.containedStatus);
    }
    if (stepToValidate === 6) return consents.c1 && consents.c2 && consents.c3;
    return false;
  };
  const canAdvance = stepIsValid(step);
  const goToNextStep = () => {
    if (canAdvance) setStep(current => Math.min(6, current + 1));
  };

  /* ── Step renders ── */
  const renderStep1 = () => (
    <div style={S.grid2}>
      <Field label="Full Name" required><TextInput value={form.reporterName} onChange={v=>u("reporterName",v)} /></Field>
      <Field label="Job Title"><TextInput value={form.jobTitle} onChange={v=>u("jobTitle",v)} /></Field>
      <Field label="Department"><TextInput value={form.department} onChange={v=>u("department",v)} /></Field>
      <Field label="Contact Email" required><TextInput value={form.contactEmail} onChange={v=>u("contactEmail",v)} type="email" /></Field>
      <Field label="Phone"><TextInput value={form.phone} onChange={v=>u("phone",v)} type="tel" /></Field>
      <Field label="Organisation"><TextInput value={form.organisation} onChange={v=>u("organisation",v)} /></Field>
    </div>
  );

  const renderStep2 = () => (
    <div style={S.grid1}>
      <div style={S.grid2}>
        <Field label="Date Discovered" required><TextInput value={form.dateDiscovered} onChange={v=>u("dateDiscovered",v)} type="date" /></Field>
        <Field label="Date Breach Occurred"><TextInput value={form.dateOccurred} onChange={v=>u("dateOccurred",v)} type="date" /></Field>
        <Field label="Breach Type" required><Select value={form.breachType} onChange={v=>u("breachType",v)} options={BREACH_TYPES} /></Field>
        <Field label="Systems Affected" required><TextInput value={form.systemsAffected} onChange={v=>u("systemsAffected",v)} placeholder="e.g. CRM, email server, cloud storage" /></Field>
      </div>
      <Field label="Description of Breach" required>
        <TextArea value={form.description} onChange={v=>u("description",v)} placeholder="Describe what happened, how it was discovered, and the sequence of events…" />
      </Field>
    </div>
  );

  const renderStep3 = () => (
    <Field label="Severity" required>
      <div style={S.sevGrid} aria-label="Severity (required)">
        {SEVERITIES.map(s => (
          <div key={s.id} style={S.sevCard(form.severity===s.id, s.id)} onClick={() => u("severity", s.id)}>
            <div style={S.sevIcon}>{s.icon}</div>
            <div style={S.sevLabel(form.severity===s.id, s.id)}>{s.label}</div>
          </div>
        ))}
      </div>
      <div style={{fontSize:12,color:"#aaa",padding:"11px 13px",background:"#fafaf8",borderRadius:8,border:"1px solid #eeede8"}}>
        Select the severity level based on potential impact to individuals and your organisation's operations.
      </div>
    </Field>
  );

  const renderStep4 = () => (
    <>
      <Field label="Data Types Involved" required>
        <div>
          {DATA_CATEGORIES.map(cat => (
            <div key={cat.label} style={S.catSection}>
              <div style={S.catTitle}>{cat.label}</div>
              <div style={S.chips}>
                {cat.items.map(it => (
                  <div key={it} style={S.chip(!!dataChecks[it])} onClick={() => toggleData(it)}>
                    <div style={S.chipBox(!!dataChecks[it])}>
                      {dataChecks[it] && <IconCheck size={8} color="#fff" />}
                    </div>
                    <span>{it}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
          <div style={{fontSize:12,color:"#888"}}>Select at least one data type.</div>
        </div>
      </Field>
      <div style={{maxWidth:220,marginTop:8}}>
        <Field label="Estimated Individuals Affected" required>
          <TextInput value={form.estimatedCount} onChange={v=>u("estimatedCount",v)} type="number" placeholder="e.g. 500" />
        </Field>
      </div>
    </>
  );

  const renderStep5 = () => (
    <div style={S.grid1}>
      <Field label="Immediate Actions Taken" required>
        <TextArea value={form.immediateActions} onChange={v=>u("immediateActions",v)} placeholder="e.g. Isolated affected servers, reset credentials, notified IT team…" />
      </Field>
      <div style={S.grid2}>
        <Field label="Breach Contained?" required>
          <Select value={form.containedStatus} onChange={v=>u("containedStatus",v)} options={["Yes — fully contained","Partially — ongoing","No — still active","Unknown"]} />
        </Field>
        <Field label="Individuals Notified?">
          <Select value={form.individualsNotified} onChange={v=>u("individualsNotified",v)} options={["Yes — notification sent","No — notification pending","Not required"]} />
        </Field>
      </div>
    </div>
  );

  const renderStep6 = () => {
    const privacyItems = [
      "Data is processed solely for breach investigation and regulatory compliance.",
      "Retained for a minimum of 3 years as required by data protection law.",
      "May be shared with CERT-In or supervisory authorities when legally required.",
      "Your contact details are used only for follow-up on this specific report.",
      "You have the right to access, correct, or delete personal data we hold about you.",
    ];
    const consentItems = [
      { k:"c1", text: <span>I confirm the information is <strong>accurate and complete</strong>, and I have the authority to submit on behalf of my organisation.</span> },
      { k:"c2", text: <span>I have read the <a href="#" style={{color:"#1a1a1a"}}>Privacy Notice</a> and <a href="#" style={{color:"#1a1a1a"}}>Data Breach Response Policy</a>, and consent to processing of my personal data for incident management.</span> },
      { k:"c3", text: <span>I understand that submitting false or misleading information may constitute a legal offence and could result in regulatory or disciplinary action.</span> },
    ];
    return (
      <>
        <div style={S.privacyBox}>
          <div style={S.privacyTitle}><IconLock /> How we process this information</div>
          {privacyItems.map((t,i) => (
            <div key={i} style={S.privacyItem}>
              <div style={S.checkDot}><IconCheck size={7} color="#888" /></div>
              <span>{t}</span>
            </div>
          ))}
        </div>
        {consentItems.map(({k,text}) => (
          <div key={k} style={S.consentItem(consents[k])} onClick={() => toggleConsent(k)}>
            <div style={S.cbox(consents[k])}>{consents[k] && <IconCheck size={9} color="#fff" />}</div>
            <div style={S.consentText}>{text}</div>
          </div>
        ))}
      </>
    );
  };

  const stepRenderers = [null,renderStep1,renderStep2,renderStep3,renderStep4,renderStep5,renderStep6];

  /* ── Success screen ── */
  if (submitted) return (
    <div style={S.root}>
      <div style={S.container}>
        <div style={S.card}>
          <div style={S.successWrap}>
            <div style={S.successIcon}><IconCheck size={26} color="#16a34a" /></div>
            <h2 style={{fontSize:17,fontWeight:600,marginBottom:6}}>Report Submitted</h2>
            <p style={{fontSize:13,color:"#888",maxWidth:320,lineHeight:1.6}}>Your data breach notification has been received and securely logged. The DPO team will respond within 24 hours.</p>
            <div style={S.refPill}>Reference: {refId}</div>
            <button style={{...S.btnGhost,marginTop:20}} onClick={() => { setSubmitted(false); setStep(1); }}>
              Submit another report
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  /* ── Form ── */
  const handleSubmit = async () => {
    if (!stepIsValid(6)) return;
    // API call placeholder — replace with your axios call
    // const payload = { ...form, dataTypes: Object.keys(dataChecks).filter(k => dataChecks[k]), reference: refId };
    // await axios.post(`${API_BASE}/manager/data-breaches`, payload, { headers });
    setSubmitted(true);
  };

  return (
    <div style={S.root}>
      <div style={S.container}>
        {/* Progress bar */}
        <div style={S.progWrap}>
          {STEPS.map((s,i) => {
            const n = i+1;
            const active = n === step;
            const done = n < step;
            const isLast = i === STEPS.length-1;
            return (
              <div key={s} style={isLast ? S.progStepLast(active,done) : S.progStep(active,done)}>
                {n}. {s}
              </div>
            );
          })}
        </div>

        {/* Card */}
        <div style={S.card}>
          <div style={S.cardHead}>
            <div style={S.cardTitle}>
              <div style={S.stepBadge}>{step}</div>
              {STEPS[step-1]}
            </div>
            <div style={S.cardSub}>{STEP_SUBS[step-1]}</div>
          </div>

          <div style={S.cardBody}>
            {stepRenderers[step]()}
          </div>

          <div style={S.cardFoot}>
            <span style={S.refTag}>{refId}</span>
            <div style={S.btns}>
              {step > 1 && (
                <button style={S.btnGhost} onClick={() => setStep(s => Math.max(1,s-1))}>
                  <IconArrowLeft /> Back
                </button>
              )}
              {step < 6 && (
                <button
                  type="button"
                  style={{...S.btnPrimary, ...(!canAdvance ? S.btnDisabled : {})}}
                  onClick={goToNextStep}
                  disabled={!canAdvance}
                  aria-disabled={!canAdvance}
                >
                  Next <IconArrowRight />
                </button>
              )}
              {step === 6 && (
                <>
                  <button style={S.btnGhost} onClick={() => {}}>Save Draft</button>
                  <button
                    type="button"
                    style={{...S.btnPrimary, ...(!canAdvance ? S.btnDisabled : {})}}
                    onClick={handleSubmit}
                    disabled={!canAdvance}
                    aria-disabled={!canAdvance}
                  >
                    <IconSend /> Submit Report
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}